<template>
  <div class="examapply">
    <TopNavBar navtitle="填写报名信息"></TopNavBar>
    <van-steps :active="active" active-icon="success" active-color="#f02958">
      <van-step>批次</van-step>
      <van-step>考点选择</van-step>
      <van-step>登记信息</van-step>
      <van-step>考级方式</van-step>
      <van-step>证件照</van-step>
      <van-step>确认</van-step>
    </van-steps>
    <div class="serviceinfo">
      <p>
        客服电话：
        <a href="tel:18302574003">18302574003</a>、
        <a href="tel:085185823989">0851-85823989</a>、<a href="tel:085185281003"
          >0851-85281003</a
        >、<a href="tel:18987099776">18987099776(云南考级办)</a>
      </p>
    </div>
    <van-form ref="infoform">
      <!-- 考试批次选择 -->
      <div class="district batch" v-show="active === 0">
        <van-radio-group v-model="ExamInfo.EB_ID" direction="horizontal">
          <van-radio
            v-for="item in ExamBatchList"
            :key="item.EB_ID"
            class="arealable"
            @click="selectBatch(item)"
            :name="item.EB_ID"
            :class="item.EB_ID == ExamInfo.EB_ID ? 'radiochecked ' : ''"
            >{{ item.EB_Name }}<br />
            <van-tag type="primary" size="medium">{{
              item | formatRegDate
            }}</van-tag>
          </van-radio>
        </van-radio-group>
      </div>
      <!-- 考点选择 -->
      <div class="district" v-show="active === 1">
        <van-radio-group v-model="ExamInfo.EA_ID" direction="horizontal">
          <van-radio
            v-for="item in ExamAreaList.filter(
              s => FeeList.filter(f => f.EA_ID == s.EA_ID).length > 0
            )"
            :key="item.EA_ID"
            class="arealable"
            :name="item.EA_ID"
            :class="item.EA_ID == ExamInfo.EA_ID ? 'radiochecked ' : ''"
            >{{ item.EA_Name }}</van-radio
          >
        </van-radio-group>
      </div>

      <!-- 登记信息 -->
      <div class="applyinfo" v-show="active === 2">
        <!-- 报考专业 -->
        <van-field
          readonly
          clickable
          name="picker"
          :value="MAG"
          label="报考专业等级"
          placeholder="选择专业等级"
          title="专业和等级"
          @click="showMPicker = true"
          :rules="[{ required: true, message: '请选择报考专业和等级' }]"
        />
        <van-popup v-model="showMPicker" position="bottom">
          <van-picker
            show-toolbar
            ref="MAG"
            :columns="profession"
            @confirm="onMConfirm"
            @cancel="showMPicker = false"
          />
        </van-popup>
        <!-- 上传听力证书 -->
        <van-field
          v-if="ExamInfo.IsSkip == 1"
          name="IsPrevCert"
          label="听力相关证明"
        >
          <template #input>
            <div>
              <van-uploader
                :after-read="afterRead"
                v-model="PrevCertPhoto"
                accept="image/jpg,image/png,image/jpeg"
                :max-count="1"
              />
            </div>
          </template>
        </van-field>
        <!-- 输入考生姓名 -->
        <van-field
          v-model="ExamInfo.Name"
          label="考生姓名"
          @change="GetPY"
          placeholder="考生姓名"
          :rules="[{ required: true, message: '请填写考生姓名' }]"
        />
        <!-- 输入姓名拼音 -->
        <van-field
          v-model="ExamInfo.NameSpell"
          label="姓名拼音"
          placeholder="姓名拼音"
          :rules="[{ required: true, message: '请填写姓名拼音' }]"
        />
        <!-- 选择证件类型 -->
        <van-field
          readonly
          clickable
          name="picker"
          :value="CertName"
          label="选择证件类型"
          placeholder="选择证件类型"
          title="证件类型"
          @click="showCertPicker = true"
          :rules="[{ required: true, message: '请选择证件类型' }]"
        />
        <van-popup v-model="showCertPicker" position="bottom">
          <van-picker
            show-toolbar
            ref="CertName"
            :columns="CertTypeList"
            value-key="CertName"
            @confirm="onCertConfirm"
            @cancel="showCertPicker = false"
          />
        </van-popup>
        <!-- 输入证件号 -->
        <van-field
          v-model="ExamInfo.CertNO"
          label="证件号"
          placeholder="证件号"
          @change="SetCertNOData"
          @click="showCertPicker = CertName == ''"
          :rules="[{ required: true, message: '请填写证件号' }]"
        />
        <van-field name="radio" label="性　　别">
          <template #input>
            <div>
              <van-radio-group v-model="ExamInfo.Sex" direction="horizontal">
                <van-radio name="男">男</van-radio>
                <van-radio name="女">女</van-radio>
              </van-radio-group>
            </div>
          </template>
        </van-field>

        <!-- 出生年月 -->
        <van-field
          readonly
          clickable
          name="calendar"
          :value="ExamInfo.BirthDate"
          label="出生日期"
          placeholder="点击选择日期"
          @click="showCalendar = true"
          :rules="[{ required: true, message: '请选择出生年月' }]"
        />
        <van-popup v-model="showCalendar" position="bottom">
          <van-datetime-picker
            v-model="BirthDate"
            @cancel="showCalendar = false"
            @confirm="SetBirthDate"
            :max-date="maxDate"
            :min-date="minDate"
            type="year-month"
          />
        </van-popup>

        <!-- 联系人 -->
        <van-field
          v-model="ExamInfo.PName"
          label="联系人"
          placeholder="联系人"
          :rules="[{ required: true, message: '请填写联系人' }]"
        />
        <!-- 输入联系电话 -->
        <van-field
          v-model="ExamInfo.PMobile"
          type="tel"
          label="联系电话"
          placeholder="联系电话"
          :rules="[{ required: true, message: '请填写联系电话' }]"
        />
        <!-- 培训机构/辅导老师 -->
        <van-field
          v-model="ExamInfo.TName"
          label="培训机构/辅导老师（请填写全称）"
          placeholder="培训机构/辅导老师（请填写全称）"
          :rules="[{ required: true, message: '请填写培训机构/辅导老师' }]"
        />
        <!-- 输入老师电话 -->
        <van-field
          v-model="ExamInfo.TMobile"
          type="tel"
          label="老师电话"
          placeholder="老师电话"
          :rules="[{ required: true, message: '请填写老师联系电话' }]"
        />

        <van-field name="radio" label="是否邮寄证书">
          <template #input>
            <div>
              <van-radio-group v-model="ExamInfo.IsPost" direction="horizontal">
                <van-radio :name="1">是</van-radio>
                <van-radio :name="0">否</van-radio>
              </van-radio-group>
            </div>
          </template>
        </van-field>

        <div class="ispost" v-if="ExamInfo.IsPost == 1">
          <!-- 收件人 -->
          <van-field
            v-model="ExamInfo.PostName"
            label="收件人"
            placeholder="收件人"
            :rules="[{ required: true, message: '请填写收件人' }]"
          />
          <!-- 输入联系电话 -->
          <van-field
            v-model="ExamInfo.PostMobile"
            type="tel"
            label="联系电话"
            placeholder="联系电话"
            :rules="[{ required: true, message: '请填写联系电话' }]"
          />
          <!-- 输入收件地址 -->
          <van-field
            v-model="ExamInfo.PostAddress"
            label="收件地址"
            placeholder="收件地址"
            :rules="[{ required: true, message: '请填写收件地址' }]"
          />
        </div>
      </div>
      <!-- 考级方式选择 -->
      <div class="district batch" v-show="active === 3">
        <div style="margin: 20px 0 20px;color: #f02958;font-size: 18px;">
          请根据自身情况选择线上或线下的方式参加考级
        </div>
        <van-radio-group v-model="ExamInfo.IsOnline" direction="horizontal">
          <van-radio
            :key="1"
            class="arealable"
            :name="1"
            :class="1 == ExamInfo.IsOnline ? 'radiochecked ' : ''"
            >线上考试</van-radio
          >
          <van-radio
            :key="0"
            class="arealable"
            :name="0"
            :class="0 == ExamInfo.IsOnline ? 'radiochecked ' : ''"
            v-if="CertNOPrefix != '53' && ExamInfo.MID != 9"
            >线下考试</van-radio
          >
        </van-radio-group>
        <div
          v-if="0 == ExamInfo.IsOnline"
          style="margin: 20px 0 20px;color: #f02958;font-size: 18px;"
        >
          如果线下考级报名人数少于50人的专业将会改为线上考级的方式进考试。考级办会提前通知考生，请考生做好准备。
        </div>
        <div
          v-if="ExamInfo.MID == 9"
          style="margin: 20px 0 20px;color: #f02958;font-size: 18px;"
        >
          音乐听力只开通线上考试
        </div>
        <div
          v-if="CertNOPrefix == '53'"
          style="margin: 20px 0 20px;color: #f02958;font-size: 18px;"
        >
          云南地区只开通线上考试
        </div>
      </div>
      <!-- 上传相片 -->
      <div class="upphoto" v-show="active === 4">
        上传相片
        <van-field name="IsPrevCert" label="近期免冠证件照">
          <template #input>
            <div>
              <van-uploader
                :after-read="afterUserPhotoRead"
                v-model="UserPhoto"
                accept="image/jpg,image/png,image/jpeg"
                :max-count="1"
              />
            </div>
          </template>
        </van-field>
        <div class="upexplain">
          <h2>上传要求：</h2>
          <img src="../assets/sketch.jpg" width="100%" alt="" />
          <p>
            1、证件照将用于<b class="danger">人脸识别和证书制作</b
            >，如果上传的证件照不符合规范要求，后果自负!
          </p>
          <p>
            2、证件照为标准小二寸考生本人正面免冠彩色半身证件照（护照照片）,<b
              class="danger"
              >照片底色不限</b
            >。需照相馆正规图片文件<b class="danger">不能手机翻拍</b>。
          </p>
          <p>
            3、文件图像格式为JPEG，图像为24位RGB真彩色，图像文件大小范围大于100Kb不超过10Mb。
          </p>
        </div>
      </div>

      <!-- 确认信息 -->
      <div class="confirminfo" v-show="active === 5">
        <div class="enrolllist">
          <ul>
            <h1>
              {{
                ExamBatchInfo && ExamBatchInfo.EB_Name
                  ? ExamBatchInfo.EB_Name
                  : ""
              }}
            </h1>
            <img class="papers" :src="ExamInfo.Photo" alt="" />
            <li>
              <label for="">考试地点：</label>
              <span>{{ EA_Name }}</span>
            </li>
            <li>
              <label for="">报考专业：</label>
              <span>{{ MName }}</span>
            </li>
            <li>
              <label for="">报考级别：</label>
              <span>{{ GName }}</span>
            </li>
            <li>
              <label for="">考生姓名：</label>
              <span>{{ ExamInfo.Name }}</span>
            </li>
            <li>
              <label for="">姓名拼音：</label>
              <span>{{ ExamInfo.NameSpell }}</span>
            </li>
            <li>
              <label for="">性　　别：</label>
              <span>{{ ExamInfo.Sex }}</span>
            </li>
            <li>
              <label for="">{{ CertName }}号：</label>
              <span>{{ ExamInfo.CertNO }}</span>
            </li>
            <li>
              <label for="">出生日期：</label>
              <span>{{ ExamInfo.BirthDate }}</span>
            </li>
            <li>
              <label for="">联系人：</label>
              <span>{{ ExamInfo.PName }}</span>
            </li>
            <li>
              <label for="">联系电话：</label>
              <span>{{ ExamInfo.PMobile }}</span>
            </li>
            <li>
              <label for="">报名时间：</label>
              <span>{{ ExamInfo.CreateTime }}</span>
            </li>
            <li v-if="ExamInfo.Fee > 0">
              <label for="">报名费：</label>
              <span class="fee">￥{{ ExamInfo.Fee }}</span>
            </li>
          </ul>
        </div>
      </div>
    </van-form>
    <div class="btn-box">
      <van-button
        type="primary"
        @click="upstep"
        class="upstep"
        round
        v-if="active > 0"
        >上一步</van-button
      >
      <van-button
        type="primary"
        @click="next"
        class="next"
        round
        native-type="submit"
        v-if="active == 1 || active == 2 || active == 3"
        >下一步</van-button
      >
      <van-button
        type="primary"
        @click="next"
        class="payment"
        round
        native-type="submit"
        v-if="active == 4"
        >确认提交</van-button
      >
      <van-button
        type="primary"
        @click="next"
        class="payment"
        round
        native-type="submit"
        v-if="active == 5"
        to="/MyEnroll"
        >我的报名</van-button
      >
    </div>
    <van-overlay :show="showload">
      <van-loading size="50px" vertical class="wrapper">加载中...</van-loading>
    </van-overlay>
    <van-overlay :show="showSubmit">
      <van-loading size="50px" vertical class="wrapper"
        >正在提交报名信息...</van-loading
      >
    </van-overlay>
    <van-overlay :show="showUpload">
      <van-loading size="50px" vertical class="wrapper">上传中...</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import TopNavBar from "@/components/TopNavBar.vue";
import {
  GetExamAreaList,
  GetAllExamBatchList,
  GetMajorsList,
  GetALLGradesList,
  ExamSignUp,
  GetExamFormInfo,
  UpdateExamForm
} from "@/api/exam";
import { Dialog, Toast } from "vant";
import { ImgUpload, GetCertTypeList } from "@/api/public";
import pinyin from "js-pinyin";
import idCode from "@/Utils/idCode";
const defaultExamInfo = {
  EB_ID: 0,
  UserID: 0,
  Name: "",
  NameSpell: "",
  EA_ID: 0,
  MID: 0,
  GID: 0,
  IsSkip: 0,
  PrevCertPhoto: "", //听力证书
  Photo: "",
  CertType: 0,
  CertNO: "",
  BirthDate: "",
  Sex: "",
  Mobile: "",
  PName: "",
  PMobile: "",
  PostMobile: "",
  PostName: "",
  PostAddress: "",
  IsPost: 0,
  CreateTime: "",
  Fee: 0,
  EF_ID: "",
  CheckStatus: "",
  IsOnline: -1
};
export default {
  components: {
    TopNavBar
  },
  data() {
    return {
      showload: true,
      active: 0,
      showCalendar: false,
      profession: new Array(),
      level: new Array(),
      showMPicker: false,
      showCertPicker: false,
      ExamAreaList: [],
      ExamInfo: Object.assign({}, defaultExamInfo),
      ExamBatchList: [],
      ExamBatchInfo: null,
      FeeList: [],
      MajorsList: null,
      GradesList: null,
      MAG: "",
      CertName: "",
      PrevCertPhoto: [],
      UserPhoto: [],
      CertTypeList: [],
      maxDate: new Date(new Date().getFullYear() - 2, new Date().getMonth(), 1),
      minDate: new Date(
        new Date().getFullYear() - 100,
        new Date().getMonth(),
        1
      ),
      BirthDate: new Date(),
      EA_Name: "",
      MName: "",
      GName: "",
      showUpload: false,
      showSubmit: false,
      CertNOPrefix: ""
    };
  },
  created() {
    this.GetInitList().then(resp => {
      if (this.$route.query.EF_ID != undefined && this.$route.query.EF_ID > 0) {
        GetExamFormInfo({ EF_ID: this.$route.query.EF_ID }).then(res => {
          this.ExamInfo = res.item;
          this.MAG =
            this.MajorsList.filter(s => s.MID == this.ExamInfo.MID)[0].MName +
            "    " +
            this.GradesList.filter(s => s.GID == this.ExamInfo.GID)[0].GName;
          this.PrevCertPhoto.push({ url: this.ExamInfo.PrevCertPhoto });
          this.UserPhoto.push({ url: this.ExamInfo.Photo });
          this.active = 2;
          this.CertName = this.CertTypeList.filter(
            s => s.CertType == this.ExamInfo.CertType
          )[0].CertName;
          let batch = this.ExamBatchList.find(
            s => s.EB_ID == this.ExamInfo.EB_ID
          );
          this.FeeList = batch ? batch.ExamBatchFees : [];
          this.SetProfession();
          let that = this;
          setTimeout(function() {
            that.showload = false;
          }, 2000);
        });
      } else {
        let that = this;
        setTimeout(function() {
          that.showload = false;
        }, 2000);
      }
    });
  },
  filters: {
    formatRegDate(item) {
      if (new Date(item.RegStartDate.replace(/-/g, "/")) > new Date()) {
        return "尚未开始报名";
      } else if (new Date(item.RegEndDate.replace(/-/g, "/")) < new Date()) {
        return "报名已经结束";
      } else {
        return "报名进行中";
      }
    }
  },
  methods: {
    SetBirthDate(val) {
      this.ExamInfo.BirthDate =
        val.getFullYear() + "." + ("0" + (val.getMonth() + 1)).slice(-2) + ".";
      this.showCalendar = false;
    },
    GetPY() {
      if (this.ExamInfo.Name !== "") {
        let spell = [];
        this.ExamInfo.Name.split("").forEach(item => {
          spell.push(pinyin.getFullChars(item).toLowerCase());
        });

        spell[0] = spell[0].charAt(0).toUpperCase() + spell[0].slice(1);
        if (spell.length > 1) {
          spell[1] = " " + spell[1].charAt(0).toUpperCase() + spell[1].slice(1);
        }
        this.ExamInfo.NameSpell = spell.join("");
      } else {
        this.ExamInfo.NameSpell = "";
      }
    },
    afterRead(file) {
      if (file.file.size > 10485760) {
        Toast.fail({ message: "上传图片不能超过10MB" });
        return;
      }
      this.showUpload = true;
      // 上传听力证书
      let data = new FormData();
      data.append("file", file.file);
      ImgUpload(data, { TypePath: "UserIMG" })
        .then(res => {
          this.ExamInfo.PrevCertPhoto = res.OtherMsg.FilePath;
          this.showUpload = false;
        })
        .catch(() => {
          this.showUpload = false;
        });
    },
    afterUserPhotoRead(file) {
      if (file.file.size > 10485760) {
        Toast.fail({ message: "上传照片不能超过10MB" });
        return;
      }
      this.showUpload = true;
      // 上传个人免冠证件照
      let data = new FormData();
      data.append("file", file.file);
      ImgUpload(data, { TypePath: "UserPhoto" })
        .then(res => {
          this.ExamInfo.Photo = res.OtherMsg.FilePath;
          this.showUpload = false;
        })
        .catch(() => {
          this.showUpload = false;
        });
    },
    next() {
      // 判断下一步条件是否满足
      switch (this.active) {
        case 1:
          if (this.ExamInfo.EA_ID == 0) {
            Toast.fail({ message: "请选择考试地区" });
            return;
          }
          //初始化专业信息
          if (!this.MajorsList || this.MajorsList.length == 0) {
            Toast.fail({ message: "当前批次没有可以报考的专业" });
            return;
          }
          this.SetProfession();
          this.active++;
          break;
        case 3:
          if (this.ExamInfo.IsOnline == -1) {
            Toast.fail({ message: "请选择参加考试的方式" });
            return;
          }
          this.active++;
          break;
        case 2:
          this.ExamInfo.IsOnline = -1;
          if (this.ExamInfo.Sex === "") {
            Toast.fail({ message: "请选择考生性别" });
            return;
          }
          if (this.ExamInfo.Sex === "") {
            Toast.fail({ message: "请选择考生性别" });
            return;
          }
          if (this.ExamInfo.CertType == 1) {
            let obj = idCode.createNew(this.ExamInfo.CertNO);
            //效验身份证号是否正确
            if (!obj.isCheck()) {
              Toast.fail({ message: "请填写正确的身份证号码" });
              return;
            }
          }
          this.$refs["infoform"]
            .validate()
            .then(() => {
              if (this.strlen(this.ExamInfo.Name) > 30) {
                Toast.fail({ message: "请输入正确的姓名" });
                return;
              }
              if (this.strlen(this.ExamInfo.PName) > 30) {
                Toast.fail({ message: "请输入正确的联系人" });
                return;
              }
              if (this.strlen(this.ExamInfo.PMobile) > 20) {
                Toast.fail({ message: "请输入正确的联系人电话" });
                return;
              }
              if (this.strlen(this.ExamInfo.TName) > 90) {
                Toast.fail({ message: "请输入正确的培训机构/老师" });
                return;
              }
              if (this.strlen(this.ExamInfo.TMobile) > 20) {
                Toast.fail({ message: "请输入正确的老师电话" });
                return;
              }
              if (this.strlen(this.ExamInfo.PostMobile) > 20) {
                Toast.fail({ message: "请输入正确的收件人联系电话" });
                return;
              }
              this.active++;
            })
            .catch(error => {
              let msg = "";
              error.forEach(item => {
                msg += item.message + "</br>";
              });
              Toast.fail({ message: msg, type: "html" });
              return;
            });
          break;
        case 4:
          if (this.ExamInfo.Photo === "") {
            Toast.fail({ message: "请上传考生的近期免冠证件照" });
            return;
          }
          Dialog.confirm({
            title: "提交",
            message: "确认要提交报名信息吗？"
          })
            .then(() => {
              this.showSubmit = true;
              if (this.ExamInfo.EF_ID > 0) {
                UpdateExamForm(this.ExamInfo)
                  .then(response => {
                    this.ExamInfo.Fee = response.OtherMsg.Fee;
                    this.ExamInfo.CreateTime = response.OtherMsg.CreateTime;
                    this.ExamInfo.CheckStatus = response.OtherMsg.CheckStatus;
                    this.ExamInfo.EF_ID = response.OtherMsg.EF_ID;
                    this.EA_Name = this.ExamAreaList.filter(
                      s => s.EA_ID == this.ExamInfo.EA_ID
                    )[0].EA_Name;
                    this.MName = this.MajorsList.filter(
                      s => s.MID == this.ExamInfo.MID
                    )[0].MName;
                    this.GName = this.GradesList.filter(
                      s => s.GID == this.ExamInfo.GID
                    )[0].GName;
                    this.showSubmit = false;
                    Toast.success({ message: "修改成功" });
                    this.active++;
                  })
                  .catch(() => {
                    return;
                  });
              } else {
                ExamSignUp(this.ExamInfo)
                  .then(response => {
                    this.ExamInfo.Fee = response.OtherMsg.Fee;
                    this.ExamInfo.CreateTime = response.OtherMsg.CreateTime;
                    this.ExamInfo.CheckStatus = response.OtherMsg.CheckStatus;
                    this.ExamInfo.EF_ID = response.OtherMsg.EF_ID;
                    this.EA_Name = this.ExamAreaList.filter(
                      s => s.EA_ID == this.ExamInfo.EA_ID
                    )[0].EA_Name;
                    this.MName = this.MajorsList.filter(
                      s => s.MID == this.ExamInfo.MID
                    )[0].MName;
                    this.GName = this.GradesList.filter(
                      s => s.GID == this.ExamInfo.GID
                    )[0].GName;
                    this.showSubmit = false;
                    Toast.success({ message: "报名成功" });
                    this.active++;
                  })
                  .catch(() => {
                    return;
                  });
              }
            })
            .catch(() => {
              Toast.fail({ message: "取消提交报名信息" });
              this.active = 2;
              return;
            });
          break;
        default:
          //全部初始化
          this.active = 0;
          this.ExamInfo = Object.assign({}, defaultExamInfo);
          break;
      }
    },
    SetProfession() {
      this.profession = new Array();
      let MajorsInfo;
      let GradesInfo;

      this.MajorsList.forEach(item => {
        MajorsInfo = this.FeeList.filter(
          s =>
            s.MID == item.MID &&
            s.EB_ID == this.ExamInfo.EB_ID &&
            s.EA_ID == this.ExamInfo.EA_ID &&
            s.Fee > 0
        );
        if (
          MajorsInfo != null &&
          MajorsInfo != undefined &&
          MajorsInfo.length > 0
        ) {
          GradesInfo = new Array();
          MajorsInfo.forEach(ginfo => {
            GradesInfo.push({
              id: ginfo.GID,
              text: this.GradesList.filter(s => s.GID == ginfo.GID)[0].GName,
              IsPrevCert: this.GradesList.filter(s => s.GID == ginfo.GID)[0]
                .IsPrevCert
            });
          });
          this.profession.push({
            id: item.MID,
            text: item.MName,
            children: GradesInfo
          });
        }
      });
    },
    upstep() {
      this.active != 0 ? this.active-- : (this.active = 0);
    },
    onConfirm(date) {
      this.value = `${date.getMonth() + 1}/${date.getDate()}`;
      this.showCalendar = false;
    },
    onMConfirm(value) {
      this.MAG = value[0] + "    " + value[1];
      let v = this.$refs.MAG.getValues();
      this.ExamInfo.MID = v[0].id;
      this.ExamInfo.GID = v[1].id;
      this.ExamInfo.IsSkip = v[1].IsPrevCert;
      this.showMPicker = false;
    },
    onCertConfirm(value) {
      this.CertName = value.CertName;
      this.ExamInfo.CertType = value.CertType;
      this.showCertPicker = false;
    },
    SetCertNOData() {
      if (this.ExamInfo.CertNO === "") {
        Toast.fail({ message: "请输入证件号" });
        return;
      }
      if (this.ExamInfo.CertType == 1) {
        let obj = idCode.createNew(this.ExamInfo.CertNO);
        //效验身份证号是否正确
        if (!obj.isCheck()) {
          Toast.fail({ message: "请填写正确的身份证号码" });
          return;
        }
        //填充出生年月
        // this.ExamInfo.BirthDate = obj.getYears() + "." + obj.getMonth() + ".";
        // this.ExamInfo.Sex = obj.getGender();
      }
    },
    selectBatch(info) {
      this.ExamBatchInfo = info;
      if (!this.ExamBatchInfo || this.ExamBatchInfo.IsLock == 1) {
        Toast.fail({ message: "请选择考试批次" });
        this.ExamInfo.EB_ID = 0;
        return;
      }
      if (
        new Date(this.ExamBatchInfo.RegStartDate.replace(/-/g, "/")) >
        new Date()
      ) {
        Toast.fail({ message: "该批次尚未开始报名" });
        this.ExamInfo.EB_ID = 0;
        return;
      }
      if (
        new Date(this.ExamBatchInfo.RegEndDate.replace(/-/g, "/")) < new Date()
      ) {
        Toast.fail({ message: "该批次报名已经结束" });
        this.ExamInfo.EB_ID = 0;
        return;
      }
      if (
        this.ExamBatchInfo.ExamBatchFees &&
        this.ExamBatchInfo.ExamBatchFees.length > 0
      ) {
        this.FeeList = this.ExamBatchInfo.ExamBatchFees;
        Dialog.confirm({
          title: "考级公告",
          message: this.ExamBatchInfo.Info
        })
          .then(() => {
            this.ExamInfo.EB_ID = this.ExamBatchInfo.EB_ID;
            this.MAG = "";
            this.ExamInfo.MID = 0;
            this.ExamInfo.EA_ID = 0;
            this.ExamInfo.GID = 0;
            this.ExamInfo.Fee = 0;
            this.active++;
          })
          .catch(() => {
            this.active = 0;
          });
        this.CertNOPrefix = this.ExamBatchInfo.CertNOPrefix;
      } else {
        Toast.fail({ message: "该批次下没有可报考的考区和科目" });
        this.ExamInfo.EB_ID = 0;
        this.CertNOPrefix = "";
      }
    },
    async GetInitList() {
      //获取所有考区信息
      await GetAllExamBatchList().then(res => {
        this.ExamBatchList = res.listData.filter(s => s.IsLock == 0);
        if (this.ExamBatchList.length == 0) {
          Toast.fail({ message: "当前没有可报名的考试批次" });
        }
      });
      //获取所有考区信息
      await GetExamAreaList({ IsPub: 1 }).then(res => {
        this.ExamAreaList = res.listData;
      });
      // 获取所有专业
      await GetMajorsList().then(res => {
        this.MajorsList = res.listData;
      });
      // 获取所有等级
      await GetALLGradesList().then(res => {
        this.GradesList = res.listData;
      });
      await GetCertTypeList().then(res => {
        this.CertTypeList = res.listData;
      });
    },
    strlen(str) {
      var len = 0;
      for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        //单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
          len++;
        } else {
          len += 2;
        }
      }
      return len;
    }
  }
};
</script>

<style>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.van-nav-bar {
  border-bottom: 5px #f2f2f2 solid;
}
.ExamApply {
  background: #f2f2f2;
  width: 100vw;
  height: 100vh;
}
.examapply .van-form {
  padding-bottom: 12vh;
}
.examapply
  .van-form
  .upphoto
  .van-cell__value
  .van-field__body
  .van-uploader__preview-image {
  width: 60%;
  height: auto;
}
.examapply .van-form .upphoto .upexplain {
  background: #fff;
  padding: 10px;
  margin: 10px auto;
  font-size: 3.2vw;
  text-align: left;
  color: gray;
}
.examapply .van-form .upphoto .upexplain h2 {
  font-size: 3.6vw;
  margin-bottom: 15px;
}
.examapply .van-form .upphoto .upexplain p {
  font-size: 3.2vw;
  line-height: 1.8;
  margin-bottom: 10px;
}
.serviceinfo p,
.serviceinfo a {
  text-align: center;
  margin: 15px 0;
  font-size: 2.933vw;
  color: #707070;
}
.district .van-radio-group {
  display: flex;
  justify-content: space-between;
}
.district .van-radio-group .van-radio {
  padding: 3%;
  width: 45%;
  background: #e1e1e1;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}
.van-dialog .van-dialog__content .van-dialog__message {
  padding: 15px;
}
.van-dialog .van-dialog__content .van-dialog__message p {
  text-align: left;
}
.batch .van-radio-group .van-radio {
  width: 96%;
}
.district .van-radio-group .van-radio:first-child {
  width: 96%;
}
.district .van-radio-group .van-radio--horizontal {
  margin: 2%;
}
.district .van-radio-group .radiochecked {
  background: linear-gradient(to right, #fb8c5b, #f02658);
}

.district .van-radio-group .radiochecked .van-radio__label {
  color: #fff;
}
.district .van-radio-group .van-radio .van-radio__icon .van-icon-success {
  border: 0;
  background: transparent;
}
/* .applyinfo .van-cell .van-field__label{width: auto;} */
.applyinfo .van-cell .van-cell__title span {
  background: transparent;
  color: #333;
}
.van-steps__items .van-step--horizontal {
  text-align: left;
}
.van-step--horizontal:first-child .van-step__title {
  font-size: 3.2vw;
}

.btn-box {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  background: #fff;
}
.btn-box .van-button {
  margin: 10px;
  width: 45%;
  border: 0;
  font-size: 4.267vw;
}
.btn-box .upstep {
  background: #5b61ec;
}
.btn-box .next {
  background: #f02958;
}
</style>
